<div class="modal">
  <div class="card">
    <div class="card-header">
      <div class="card-title">Unesi dodatni artikal</div>
    </div>
    <div class="card-body">
      <div [formGroup]="articleForm">
        <div class="form-group">
          <label class="form-label">Naziv artikla *</label>
          <app-product-autocomplete (selected)="onSelectProduct($event)" [excludeFinishedProducts]="true"></app-product-autocomplete>
        </div>
        <div class="form-group">
          <label class="form-label">Količina *</label>
          <input type="number" name="quantity" class="form-control" formControlName="quantity" />
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" [disabled]="articleForm.invalid">Potvrdi</button>
    </div>
  </div>
</div>
